export default __webpack_public_path__ + "static/media/Youtube.965fed80.png";